export default __webpack_public_path__ + "static/media/radio-selected-tick.83762645.svg";